export const calculatePercentage = (value = 0, baseValue = 0): number =>
  baseValue === 0 ? 0 : (value / baseValue) * 100;

export const minutesToRoundedHours = (minutes: number): number =>
  minutes < 0 ? Math.ceil(minutes / 60) : Math.floor(minutes / 60);
